import React, { useContext, useEffect, useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu'
import { Button, Drawer, FormControl, InputAdornment, InputLabel, MenuItem, Select, Switch, TextField, Tooltip, Zoom } from '@mui/material';

import { GetRequest } from '../../api/crudSolicitud/GetRequest.api';
import LoginContext from '../../context/login_context/LoginContext';
import { UpdateSoli } from '../../api/crudSolicitud/UpdateSoli.api';
import { URL_SRV_RAIZ } from '../../router/Url';
import { PostWo } from '../../api/crudSolicitud/PostWo.api';
import { ModalLoaded } from '../../component/ModalLoaded.component';

import SyncAltIcon from '@mui/icons-material/SyncAlt';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PreviewIcon from '@mui/icons-material/Preview';
import { AddLog } from '../../api/crudSolicitud/AddLog.api';

const label = { inputProps: { 'aria-label': 'Size switch demo' } };

let RutAdmins = [
  "16114499-1",//MURRUTIA
  "17687529-1",//VMATURANA
  "16520167-1",//ABARRERA
  "17049061-4",//PEGUTIERREZ
  "18.693.447-4",//fareyes
  "19684645-K",//ANDRES MELILLAN
  "17461699-K",//marisol ibarra
  "18061498-2",//MAURICIO FUENTES
  "16154946-0",//ivan ulloa
  "20267595-6",//joaKING
]


export const RevisarSolicitudes = () => {

    const [ModalLoadded, setModalLoadded] = useState(false);
    const [TextoModal, setTextoModal] = useState("");

    const {LoginState} = useContext(LoginContext);
    // console.log(LoginState)

    const [SoliSelected, setSoliSelected] = useState();
    const [StateChanged, setStateChanged] = useState("");
    const [notesChanged, setNotesChanged] = useState("");

    const [FechaIncidente, setFechaIncidente] = useState("");

    const [UserListFracttal, setUserListFracttal] = useState([])
    const [UserListFracttal_BKP, setUserListFracttal_BKP] = useState([])
    const [checked, setChecked] = React.useState(true);


    const [SolicitudesList, setSolicitudesList] = useState([]);
    const [SolicitudesListBKP, setSolicitudesListBKP] = useState([]);

    // datos para planificar tarea
    const [ActivoPT, setActivoPT] = useState("");
    const [RecHumPT, setRecHumPT] = useState("");
    const [SolicitadoPT, setSolicitadoPT] = useState("");
    const [DescripctPT, setDescripctPT] = useState("");
    const [TipoTarePT, setTipoTarePT] = useState("");
    const [TipoTrabajoPT, setTipoTrabajoPT] = useState("");
    const [CodigoSoliPT, setCodigoSoliPT] = useState("");
    const [TipoOT_, setTipoOT_] = useState("Planificada");

    const [ModalState, setModalState] = useState(false);
    const [ModalStateSoli, setModalStateSoli] = useState(false);

    const [priority, setpriority] = useState(3);

    const [stateDW_OT, setStateDW_OT] = useState({
        top: false,
        left: false,
        bottom: false,
        right: false,
    });
    const toggleDrawer_OT = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setStateDW_OT({ ...stateDW_OT, [anchor]: open });
        setSoliSelected("")
        setFechaIncidente("")
        //limpiar los datos de la planificacion
        setStateChanged("");
        setRecHumPT("");
        setDescripctPT("");
        setActivoPT("");
        setSolicitadoPT("");
        setTipoTarePT("");
        setCodigoSoliPT("");
        setChecked(true);
    };

    const GetSolicitudes = async () => {
        // Aquí iría la lógica para obtener las solicitudes desde el backend
        await setModalLoadded(true)
        let ahora = new Date();
        let hoy = new Date().getTime();
        let hace_1_mes = new Date(ahora.getFullYear(), ahora.getMonth() - 6, ahora.getDate()).getTime();

        let soli_list = await GetRequest({since: hace_1_mes, until: hoy, planta: LoginState.planta});

        let soli_list_sort = soli_list.sort((a, b) => b.id_code - a.id_code);

        await setSolicitudesList(soli_list_sort);
        await setSolicitudesListBKP(soli_list_sort);
        await setModalLoadded(false)
        // console.log("=>",soli_list,{since: hace_1_mes, until: hoy, planta: LoginState.planta})
    }

    const traducemeStatus_ = (status) => {
        switch (status) {
            case 1:
                return "ABIERTA";
            case 2:
                return "EN PROCESO";
            case 4:
                return "RESUELTA SIN OT";
            case 5:
                return "CANCELADA";
            case 12:
                return "RECHAZADA";
            
            default:
                return status;
        }
    }

    const getLogStatusChanges = async () => {
        // Aquí iría la lógica para obtener los logs de cambios de estado desde el backend
        let items = await AddLog({
            pagina: 1,
            n_pp: 10,
            action: "READ",
        })
        console.log("items:", items)
    }

    // cambia el estado de la solicitud
    const handleChangeSoli = async () => {
        // console.log("Cambiar estado de solicitud", SoliSelected.id_code, StateChanged, notesChanged,LoginState.planta);
        await UpdateSoli({id_code: SoliSelected.id_code, status: StateChanged, notes: notesChanged, planta: LoginState.planta})

        //agregar datos de usuario par log de cambios de estados
        await AddLog({
            id_code: SoliSelected.id_code,
            status_old: traducemeStatus(SoliSelected.requests_x_status_description),
            status_new: traducemeStatus_(StateChanged),
            notes: notesChanged,
            user: LoginState.user,
            planta: LoginState.planta,
            action: "CREATE",
            timestamp: new Date().getTime()
        })

        // setSolicitudesList([])
        //al finalizar la logica limpia los datos
        await setModalState(false);
        await setStateChanged("");
        await setNotesChanged("");
        await GetSolicitudes()
        alert("Estado de solicitud actualizado correctamente");
    }

    useEffect(() => {
        GetSolicitudes()
      return () => {
        
      }
    }, [])

    useEffect(() => {
        // VERIFICACION DE URGENCIA DE OT
        if(SoliSelected?.is_urgent === true){
            setChecked(false);
            setTipoOT_("Programada");
            setpriority(2);
        }else{
            setpriority(3);
        }

        // VERIFICACION DE TIPO DE TRABAJO
        if(SoliSelected?.types_1_description){
            setTipoTrabajoPT(SoliSelected?.types_1_description);
            console.log(SoliSelected?.types_1_description);
        }

    }, [SoliSelected])
    

    const handleChange = (event) => {
        // console.log(event.target.checked)
        setChecked(event.target.checked);
        // Planificada o Programada
        if (event.target.checked) {
            setTipoOT_("Planificada");
            setFechaIncidente("");
        } else {
            setTipoOT_("Programada");
        }
    };

    const HandleCrearOT = async () => {
        await setTextoModal("Creando OT ...");
        await setModalLoadded(true)
        console.log({
            id_code:SoliSelected.id_code,
            type:TipoTrabajoPT,
            programado:FechaIncidente===""?"":FechaIncidente+":00-03",
            responsable:RecHumPT,
            name:SoliSelected.accounts_name,
            type_pending:TipoOT_,
            planta:LoginState.planta,
            priority:priority
        });
        
        // envia los datos para crear la OT
        let resOT = await PostWo({
            id_code:SoliSelected.id_code,
            type:TipoTrabajoPT,
            programado:FechaIncidente===""?"":FechaIncidente+":00-03",
            responsable:RecHumPT,
            name:SoliSelected.accounts_name,
            type_pending:TipoOT_,
            planta:LoginState.planta,
            priority:priority
        })

        console.log(resOT.data.wo_folio)

        GetSolicitudes()
        setStateDW_OT({ ...stateDW_OT, ["bottom"]: false });
        setSoliSelected("")
        setFechaIncidente("")
        //limpiar los datos de la planificacion
        setStateChanged("");
        setRecHumPT("");
        setDescripctPT("");
        setActivoPT("");
        setSolicitadoPT("");
        setTipoTarePT("");
        setCodigoSoliPT("");
        setChecked(true);
        await setTextoModal("");
        await setModalLoadded(false)
        alert("OT creada correctamente con el numero: "+resOT.data.wo_folio);
        
    }

    const LimitDescription = (e) => {
        const maxLength = 200;
        if (e.length <= maxLength) {
            setDescripctPT(e);
        }
    }

    const traducemeStatus = (status) => {
        switch (status) {
            case "OPEN_STATUS":
                return "ABIERTA";
            case "SOLVED_WITHOUT_OT_STATUS":
                return "RESUELTA SIN OT";
            case "CANCEL_STATUS":
                return "CANCELADA";
            case "OT_IN_PROCESS":
                return "OT EN PROCESO";
            case "REJECTED":
                return "RECHAZADA";
            case "AGAIN_REQUEST_TODO":
                return "ESPERANDO OTRO OT";
            case "SOLVED_WITH_OT_STATUS":
                return "RESUELTA CON OT";
            case "OT_IN_REVIEW":
                return "OT EN REVISION";   
            case "REQUEST_TODO":
                return "EN ESPERA DE UNA OT";
            case "DELETE_TASK_TODO":
                return "TAREA ELIMINADA";
            case "PROCESS_STATUS":
                return "EN PROCESO";
            default:
                return status;
        }
    }

    const [turnoState, setturnoState] = useState([])
    const calculeTurno = async () => {
        let fecha = new Date();
        // fecha.setHours(fecha.getHours()+9); // Set to the start of the day
        //2025-08-12T15:24:18.629Z
        let hora = fecha.getHours();
        let minuto = fecha.getMinutes();
        if(hora === 23){
            //next day
            fecha.setDate(fecha.getDate() + 1);
            setturnoState([
                {value:`${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()}T07:15:00.000Z`, label:`Turno Mañana: ${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()} 07:15:00`},
                {value:`${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()}T15:15:00.000Z`, label:`Turno Tarde: ${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()} 15:15:00`}
            ])
        }else{
            if(hora >= 0 && hora < 7){
                setturnoState([
                    {value:`${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()}T07:15:00.000Z`, label:`Turno Mañana: ${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()} 07:15:00`},
                    {value:`${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()}T15:15:00.000Z`, label:`Turno Tarde: ${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()} 15:15:00`}
                ])
            }
            if(hora >= 7 && hora < 15){
                setturnoState([
                    {value:`${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()}T15:15:00.000Z`, label:`Turno Tarde: ${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()} 15:15:00`},
                    {value:`${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()}T23:15:00.000Z`, label:`Turno Noche: ${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()} 23:15:00`},
                ])
            }
            if(hora >= 15 && hora < 23){
                setturnoState([
                    {value:`${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()+1}T23:15:00.000Z`, label:`Turno Noche: ${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()} 23:15:00`},
                    {value:`${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth()+1)}-${fecha.getDate()+1}T07:15:00.000Z`, label:`Turno Mañana: ${fecha.getFullYear()}-${(fecha.getMonth()+1)<10?'0'+(fecha.getMonth()+1):(fecha.getMonth())}-${fecha.getDate()+1} 07:15:00`}
                ])
            }
        }
        
        // console.log(hora, minuto)
    }

    useEffect(() => {
        
        calculeTurno();
        const intervalId = setInterval(() => {
            calculeTurno();
        }, 1000*10);

        const LoadUsersFromFracttal = async () => {
          let query = await fetch(URL_SRV_RAIZ+'getuser_fracttal_planta_nof',{//'getuser_fracttal',{
            method: "POST",
            headers: {
              'authorization': "marcuxo",
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              PLANTA: LoginState.planta.toUpperCase()
            })
          })
    
          let responsio = await query.json();
          let map = await responsio.body.map((item) => {
              let {CODIGO,NOMBRE,CARGO} = item
              return { value: CODIGO, label: NOMBRE , CARGO: CARGO.toUpperCase() }
            })
            //   console.log("Usuarios Fracttal",map);

            setUserListFracttal(map);
            setUserListFracttal_BKP(map);
        }
        LoadUsersFromFracttal()
        return () => {
            // Cleanup if necessary
            clearInterval(intervalId);
        }
    }, [])

    useEffect(() => {
        if(TipoTrabajoPT !== ""){
            let filterList = UserListFracttal.filter(item => item.CARGO.toLowerCase().includes(TipoTrabajoPT.toLowerCase()));
            setUserListFracttal_BKP(filterList);
          }else{
            setUserListFracttal_BKP(UserListFracttal);
          }
    }, [TipoTrabajoPT])
    
    const [Orden, setOrden] = useState("DESC");//DESC || ASC
    const [OrdenTxt, setOrdenTxt] = useState("");//Item de tabla
    const [first, setFirst] = useState([]);

    function ordenarData(data, key, ord = 'ASC') {
    if (!Array.isArray(data)) throw new TypeError('data debe ser un array');
    const arr = [...data]; // clonar para no mutar el original
    const order = (ord || 'ASC').toUpperCase(); // normalizar

    const tryParseDate = (v) => {
        if (typeof v !== 'string') return null;
        const m = v.match(/^(\d{4})-(\d{2})\/(\d{4})?\s+(\d{2}):(\d{2}):(\d{2})$/);
        if (m) {
        // const [, yyyy, mm, dd, HH, MM, SS] = m;
        // const ts = Date.parse(`${yyyy}-${mm}-${dd}T${HH}:${MM}:${SS}Z`);
        const ts = Date.parse(m);
        return isNaN(ts) ? null : ts;
        }
        const ts = Date.parse(v);
        return isNaN(ts) ? null : ts;
    };

    const norm = (v) => {
        if (v == null) return { t: 'null', v: -Infinity };
        if (typeof v === 'number') return { t: 'num', v };
        if (typeof v === 'boolean') return { t: 'num', v: v ? 1 : 0 };
        if (typeof v === 'string') {
        const num = Number(v.replace(/,/g, ''));
        if (!isNaN(num) && v.trim() !== '') return { t: 'num', v: num };
        const d = tryParseDate(v);
        if (d != null) return { t: 'date', v: d };
        return { t: 'str', v: v.toLowerCase() };
        }
        return { t: 'str', v: JSON.stringify(v).toLowerCase() };
    };

    arr.sort((a, b) => {
        const A = norm(a[key]);
        const B = norm(b[key]);
        const typePriority = { num: 3, date: 3, str: 2, null: 1 };
        const tpA = typePriority[A.t] || 0;
        const tpB = typePriority[B.t] || 0;
        if (tpA !== tpB) return (tpB - tpA) * (order === 'ASC' ? -1 : 1);

        let cmp = 0;
        if (A.v < B.v) cmp = -1;
        else if (A.v > B.v) cmp = 1;

        if (order === 'DESC') cmp = -cmp;
        return cmp;
    });

    setOrdenTxt(key);//item para ordenar
    setOrden(order === 'ASC' ? 'DESC' : 'ASC');
    // console.log(arr)
    setSolicitudesListBKP(arr);//resultado del array ordenado
    return arr;
    }

    return (<>
        <HeaderMenu Pag_Sel={'rev_solicitudes'} />

        <div className='container-fluid'>
            <div className='row'>
                <div className='col-12'>
                    <h3 className='mt-3'>Revisar Solicitudes</h3>
                </div>

                <div className='col-12 my-2'>
                    <div className='row'>
                        <div className='col-md-3'>
                            <TextField
                                label="Buscar por descripción o activo"
                                variant="outlined"
                                size='small'
                                fullWidth
                                // value={searchTerm}
                                onChange={(e) => {
                                    if (e.target.value.length > 0) {
                                        let filterList = SolicitudesList.filter(item => item.items_description.toLowerCase().includes(e.target.value.toLowerCase()) ||
                                            item.description.toLowerCase().includes(e.target.value.toLowerCase()) ||
                                            item.requested_by.toLowerCase().includes(e.target.value.toLowerCase())
                                        );
                                        setSolicitudesListBKP(filterList);
                                    } else {
                                        setSolicitudesListBKP(SolicitudesList);
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className='col'>
                    <div
                        className='row py-2 mx-2 puntero'
                        title='Clic para Ordenar de manera Ascendente o Descendente.'
                        style={{backgroundColor: '#000000', color: "#ffffff", cursor: 'pointer'}}
                    >
                        <div style={{width:'8%'}} onClick={()=>ordenarData(SolicitudesListBKP, "id_code", Orden)}>
                            <small>Nro. Solicitud{OrdenTxt === "id_code" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
                        </div>
                        <div style={{width:'10%'}} onClick={()=>ordenarData(SolicitudesListBKP, "requested_by", Orden)}>
                            <small>Solicitante{OrdenTxt === "requested_by" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
                        </div>
                        <div style={{width:'10%'}} onClick={()=>ordenarData(SolicitudesListBKP, "requests_x_status_description", Orden)}>
                            <small>Estado{OrdenTxt === "requests_x_status_description" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
                        </div>
                        <div style={{width:'25%'}} onClick={()=>ordenarData(SolicitudesListBKP, "description", Orden)}>
                            <small>Descripción{OrdenTxt === "description" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
                        </div>
                        <div style={{width:'10%'}} onClick={()=>ordenarData(SolicitudesListBKP, "is_urgent", Orden)}>
                            <small>Urgente?{OrdenTxt === "is_urgent" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
                        </div>
                        <div style={{width:'23%'}} onClick={()=>ordenarData(SolicitudesListBKP, "items_description", Orden)}>
                            <small>Activo{OrdenTxt === "items_description" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
                        </div>
                        <div style={{width:'7%'}} onClick={()=>ordenarData(SolicitudesListBKP, "date", Orden)}   >
                            <small>Fecha Creación{OrdenTxt === "date" ? Orden === "ASC" ? " ↓" : " ↑" : null}</small>
                        </div>
                        <div style={{width:'7%'}}>
                            <small>Acciones</small>
                        </div>
                    </div>

                    <div className='col mb-2 ml-1' style={{height: '70vh', overflowY: 'scroll', padding: '0px', margin: '0px'}}
                        // onScroll={(e)=>console.log(e.target.offsetHeight,e.target.scrollTop.toFixed(2),e.target.scrollHeight)}
                    >
                        {/* <div className='row' style={{width: '100%'}}> */}
                            {
                                SolicitudesListBKP.map((item, index) => (
                                    <div key={index} className='row sobre-m' style={{width: '100%', marginLeft: "0px"}}>
                                        <td style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '8%', paddingLeft: '5px'}}>
                                            <small>{item?.id_code}</small>
                                        </td>
                                        <td style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '10%', paddingLeft: '5px'}}>
                                            <small>{item?.requested_by}</small>
                                        </td>
                                        <td style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '10%'}}>
                                            <small>{traducemeStatus(item?.requests_x_status_description)}</small>
                                        </td>
                                        <td style={{width: '25%'}}>
                                            <small>{String(item?.description).toUpperCase()}<br/> {item?.observation&&String(item?.observation).toUpperCase()} </small>
                                        </td>
                                        <td style={{alignContent: 'center', width: '10%',  paddingLeft: '8px'}} className=''>
                                            <small><b>{item.is_urgent ? "SI" : "NO"}</b></small>
                                        </td>
                                        <td style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '22%'}}>
                                            <small>{item?.items_description}</small>
                                        </td>
                                        <td style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '8%'}} className='text-center'>
                                            <small>{new Date(item.date).toLocaleString()}</small>
                                        </td>
                                        <td className='text-center' style={{alignItems: 'center', justifyContent: 'center', alignContent: 'center', width: '7%'}}>
                                            {
                                                item.requests_x_status_description === "OPEN_STATUS" ||
                                                item.requests_x_status_description === "PROCESS_STATUS" ||
                                                item.requests_x_status_description === "REJECTED" ? <>
                                                <Tooltip title="Cambiar Estado" placement="top-start" arrow slots={{ transition: Zoom }}>
                                                    <span
                                                        className='puntero btn-tb'
                                                        onClick={() => {setModalState(true); setSoliSelected(item);}}
                                                    >
                                                        <SyncAltIcon htmlColor='#9f9f9f' />
                                                    </span>
                                                </Tooltip></>:null
                                            }

                                            {
                                                item?.requests_x_status_description==="OPEN_STATUS" || 
                                                item?.requests_x_status_description==="PROCESS_STATUS" ?<Tooltip title="Planificar Tarea" placement="top-start" arrow slots={{ transition: Zoom }}>
                                                    <span
                                                        onClick={() => {setStateDW_OT({ ...stateDW_OT, bottom: true }); setSoliSelected(item);console.log(item);}}
                                                        className='puntero btn-tb'
                                                    >
                                                        <CalendarMonthIcon htmlColor='#9f9f9f' />
                                                    </span>
                                                </Tooltip> : null 
                                            }
                                            <Tooltip title="Ver Solicitud" placement="top-start" arrow slots={{ transition: Zoom }}>
                                                <span
                                                    onClick={() => {setModalStateSoli(true); setSoliSelected(item);console.log(item);}}
                                                    className='puntero btn-tb'
                                                >
                                                    <PreviewIcon htmlColor='#9f9f9f' />
                                                </span>
                                            </Tooltip>
                                        
                                        </td>
                                    </div>
                                ))
                            }
                        {/* </div> */}
                    </div>
                    
                </div>
            </div>
        </div>

        {/* modal cambio de estado */}
        {
            ModalState &&
            <div className="modal show" style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}} id="cambiarClaveModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Cambiar estado solicitud</h5>
                    </div>
                    <div className="modal-body">
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12 py-2 text-right'>
                                <small style={{color: '#9f9f9f'}}>Estado actual {traducemeStatus(SoliSelected.requests_x_status_description)}</small>
                            </div>
                            <div className='col-12'>
                                <FormControl fullWidth>
                                    <InputLabel size='small' id="demo-simple-select-label">Seleccione Estado</InputLabel>
                                    <Select
                                        size='small'
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        label="Seleccione Estado"
                                        value={StateChanged}
                                        onChange={(e)=>setStateChanged(e.target.value)}
                                    >
                                        {traducemeStatus(SoliSelected.requests_x_status_description)==="ABIERTA"?null:<MenuItem value={1}>Abierta</MenuItem>}
                                        <MenuItem value={5} title='El solicitante cancelo la solicitud.'>Cancelada</MenuItem>
                                        {traducemeStatus(SoliSelected.requests_x_status_description)==="EN PROCESO"?null:<MenuItem value={2} title='Se estan tomando acciones.'>En Proceso</MenuItem>}
                                        {traducemeStatus(SoliSelected.requests_x_status_description)==="RECHAZADA"?null:<MenuItem value={12} title='El area que ejecuta el trabajo rechazo la solicitud.'>Rechazada</MenuItem>}
                                        <MenuItem value={4} title='Algun trabajo para el cual no fue necesario realizar una OT.'>Resuelta sin OT</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div className='col-12 mt-3'>
                                <TextField
                                    size='small'
                                    rows={2}
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    label="Descripción del Cambio"
                                    value={notesChanged}
                                    onChange={(e) => setNotesChanged(e.target.value.toUpperCase())}
                                />
                            </div>
                        </div>
                    </div>

                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            data-dismiss="modal"
                            onClick={()=>{
                                setModalState(false)
                                setStateChanged("")
                                setNotesChanged("")
                                // setSelectedItem()
                                // setCambioClave("")
                            }}
                        >Cerrar</button>
                        <button
                            disabled={StateChanged!=="" && notesChanged!=="" ? false : true}
                            type="button"
                            className="btn btn-sm btn-danger"
                            onClick={()=>handleChangeSoli()}
                        >Cambiar</button>
                    </div>
                    </div>
                </div>
            </div>
        }

        {/* modal ver solicitud */}
        {
            ModalStateSoli &&
            <div className="modal show" style={{display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)'}} id="cambiarClaveModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Datos de solicitud</h5>
                        {/* <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button> */}
                    </div>
                    <div className="modal-body">
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='container-fluid '>
                                <div className='row'>
                                    <div className='col-12'>
                                        <span className='small'><b>Solicitud Nro:</b> {SoliSelected?.id_code}</span><br/>
                                        <span className='small'><b>Fecha Solicitud:</b> {new Date(SoliSelected?.date).toLocaleString()}</span><br/>
                                        <span className='small'><b>Solicitante:</b> {SoliSelected?.accounts_name}</span><br/>
                                        <span className='small'><b>Activo:</b> {SoliSelected?.items_description}</span><br/>
                                        <span className='small'><b>Descripción:</b> {SoliSelected?.description}</span><br/>
                                        <span className='small'><b>Observación:</b> {SoliSelected?.observation}</span><br/>
                                        <span className='small'><b>OT:</b> {SoliSelected?.wo_folio}</span><br/>
                                        <span className='small'><b>Ceco:</b> {SoliSelected?.costs_center_description}</span><br/>
                                        <span className='small'><b>Tipo:</b> {SoliSelected?.groups_description}</span><br/>
                                        <span className='small'><b>Clasificación 1:</b> {SoliSelected?.groups_1_description}</span><br/>
                                        <span className='small'><b>Clasificación 2:</b> {SoliSelected?.groups_2_description}</span><br/>
                                        <span className='small'><b>Prioridad:</b> {traduce_priory[SoliSelected?.priorities_description]}</span><br/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-sm btn-secondary"
                            data-dismiss="modal"
                            onClick={()=>{
                                setModalStateSoli(false)
                                setStateChanged("")
                                setNotesChanged("")
                                setSoliSelected()
                            }}
                        >Cerrar</button>
                    </div>
                    </div>
                </div>
            </div>
        }

        {/* drawer planificar tarea */}
            <Drawer
                anchor={'bottom'}
                open={stateDW_OT['bottom']}
                // onClose={toggleDrawer_OT('bottom', false)}
            >
                <div className='container-fluid mb-5' style={{maxHeight: '80vh', overflowY: 'auto'}}>
                    <div className='row'>
                        <div className='col-12 bg-primary text-white p-2 mb-3'>
                            <span className='lead'><b>Planificar Tarea</b></span>
                        </div>
                        
                        <div className='container-fluid'>
                            <div className='row'>
                                <div className='col-12 col-md-9 pt-3'>
                                    <TextField
                                        focused
                                        size='small'
                                        fullWidth
                                        variant="outlined"
                                        label="Activo"
                                        value={SoliSelected?.items_description}//dato por parametro
                                    />
                                </div>

                                <div className='col-12 col-md-3 pt-3'>
                                    <TextField
                                        size='small'
                                        fullWidth
                                        variant="outlined"
                                        label="Codigo de Solicitud"
                                        value={SoliSelected?.id_code}//dato por parametro 
                                    />
                                </div>

                                <div className='col-12 col-md-4 pt-3'>
                                    <FormControl fullWidth>
                                        <InputLabel size='small' id="demo-simple-select-label">Tipo de trabajo</InputLabel>
                                        <Select
                                            size='small'
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Tipo de trabajo"
                                            value={TipoTrabajoPT}
                                            onChange={(e)=>setTipoTrabajoPT(e.target.value)}
                                        >
                                            {/* <MenuItem value={"EFICIENCIA ENERGETICA"}>Eficiencia Energetica</MenuItem> */}
                                            {/* <MenuItem value={"ADMINISTRATIVO"}>Administrativo</MenuItem> */}
                                            <MenuItem value={"ELECTRICA"}>Eléctrica</MenuItem>
                                            {/* <MenuItem value={"EXTERNO"}>Externo</MenuItem> */}
                                            <MenuItem value={"MECANICA"}>Mecánica</MenuItem>
                                            <MenuItem value={"REDES Y SERVICIOS"}>Redes y Servicios Eléctricos</MenuItem>
                                            <MenuItem value={"SALA DE MAQUINAS"}>Sala de Máquinas</MenuItem>
                                            <MenuItem value={"SERVICIOS VARIOS"}>Servicios Varios</MenuItem>
                                            {/* <MenuItem value={"-"}>No categorizados</MenuItem> */}
                                        </Select>
                                    </FormControl>
                                </div>
                                

                                <div className='col-12 col-md-4 pt-3'>
                                    <TextField
                                        focused
                                        size='small'
                                        fullWidth
                                        variant="outlined"
                                        label="Solicitador por"
                                        value={SoliSelected?.accounts_name}//dato por parametro
                                    />
                                </div>

                                <div className='col-12 col-md-4 pt-3'>
                                    <FormControl fullWidth>
                                        <InputLabel size='small' id="demo-simple-select-label">Responsable</InputLabel>
                                        <Select
                                            size='small'
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Responsable"
                                            value={RecHumPT}
                                            onChange={(e)=>setRecHumPT(e.target.value)}
                                        >
                                            {
                                                UserListFracttal_BKP.map((usrfttl, index)=>
                                                    <MenuItem key={index} style={{fontFamily: 'monospace',fontSize: '10'}}  value={usrfttl.value}><small>{usrfttl.label}</small></MenuItem>
                                                )
                                            }
                                        </Select>
                                    </FormControl>
                                </div>
                                
                                
                                <div className='col-12 pt-3 text-right'>
                                    <TextField
                                        multiline
                                        rows={4}
                                        size='small'
                                        fullWidth
                                        variant="outlined"
                                        label="Descripcion"
                                        value={DescripctPT}
                                        onChange={(e)=>LimitDescription(e.target.value.toUpperCase())}
                                    />
                                    <small>{DescripctPT.length}/200</small>
                                </div>

                                <div className='col-12 col-md-4 mt-4'>
                                    <span>OT EN PROCESO</span>
                                    <Switch {...label} defaultChecked checked={checked} onChange={handleChange} />
                                    <span>TAREA PENDIENTE</span>
                                </div>

                                {
                                !checked ?<div className='col-12 col-md-4 mt-3'>
                                        <select
                                            className="form-control"
                                            id="exampleFormControlSelect123"
                                            placeholder='SELECCIONE TURNO'
                                            value={FechaIncidente}
                                            onChange={(e)=>{setFechaIncidente(e.target.value);console.log(e.target.value)}}
                                        >
                                            <option selected value={null}>SELECCIONE TURNO</option>
                                            {
                                                turnoState&&turnoState.map((turno, index) => (
                                                <option key={index} value={turno.value}>{turno.label}</option>
                                                ))
                                            }
                                        </select>
                                </div>
                                :<div className='col-12 col-md-4'>
                                <span className='fotmar-inp-date-label'>Fecha Programada</span>
                                    <input
                                        type='date'
                                        className='fotmar-inp-date'
                                        // max={new Date().toISOString().split('T')[0]}
                                        value={FechaIncidente}
                                        onChange={(e)=>{setFechaIncidente(e.target.value);console.log(e.target.value)}}
                                    />
                                </div>
                                }

                                 <div className='col-12 col-md-4 mt-3'>
                                    <FormControl size='small' fullWidth>
                                        <InputLabel id="demo-simple-select-label">Prioridad</InputLabel>
                                        <Select
                                            size='small'
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Prioridad"
                                            value={priority}
                                            onChange={(e)=>setpriority(e.target.value)}
                                        >
                                            <MenuItem value={4} title='TEXTO'>BAJA</MenuItem>
                                            <MenuItem value={3} title='TEXTO'>MEDIA</MenuItem>
                                            <MenuItem value={2} title='TEXTO'>ALTA</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                
                            </div>
                        </div>

                        <div className='col-12 text-right mt-3'>
                            <Button variant="contained" size='small' color="error" onClick={toggleDrawer_OT('bottom', false)}>
                                Cancelar
                            </Button>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <Button
                                disabled={RecHumPT==="" || TipoTrabajoPT==="" || DescripctPT ==="" || (FechaIncidente==="" && !checked) ? true : false}
                                variant="contained"
                                size='small'
                                color="success"
                                onClick={()=>HandleCrearOT()}>
                                Aceptar
                            </Button>
                        </div>
                    </div>

                </div>
            </Drawer>

        {
            ModalLoadded?<ModalLoaded texto={"Cargando Solicitudes ... " || TextoModal} />:null
        }

  </>
  )
}

const traduce_priory = {
    "VERY_HIGH": "MUY ALTA",
    "HIGH": "ALTA",
    "MEDIUM": "MEDIA",
    "LOW": "BAJA",
    "VERY_LOW": "MUY BAJA",
}